import { render } from "./items_counter.vue?vue&type=template&id=9f97ec56"
import script from "./items_counter.vue?vue&type=script&lang=js"
export * from "./items_counter.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__